module.exports = __webpack_public_path__ + "img/8.dirty_floor.6a74d1e5.svg";